(ns com.theplantscape.web-ui.tailwind.lists)

(defn simple-list
  [items formatter]
  (into [:ul.divide-y-2.divide-gray-400.align-middle]
        (mapv (fn [row]
                [:li.flex.justify-between.justify-center.p-3.hover:bg-blue-600.hover:text-blue-200 (formatter row)])
              items)))

;; [:div {:class "w-full bg-white rounded-lg shadow-lg lg:w-1/3"}
;;  (into [:ul.divide-y-2.divide-gray-400]
;;        (mapv (fn [row] 
;;                 [:li.flex.justify-between.p-3.hover:bg-blue-600.hover:text-blue-200 "
;;             Edit List Item
;;             " [:svg.w-6.h-6.text-blue-600 {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewbox "0 0 24 24" :stroke "currentColor"} [:path {:stroke-linecap "round" :stroke-linejoin "round" :stroke-width "2" :d "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"}]]] [:li.flex.items-center.justify-between.p-3.hover:bg-blue-600.hover:text-blue-200 "
;;             Messages
;;             " [:span.px-2.py-1.text-sm.text-blue-200.bg-blue-600.rounded-full "+1"]]) items))]
